import { showDialog } from 'vant'
/* global WeixinJSBridge */
const onBridgeReady=(options)=>{
    WeixinJSBridge.invoke('getBrandWCPayRequest', options,
        function (res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
                // 使用以上方式判断前端返回,微信团队郑重提示：
                //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠，商户需进一步调用后端查单确认支付结果。
                showAlert("支付成功");
            } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
                showAlert("支付取消");
            } else if (res.err_msg == "get_brand_wcpay_request:fail") {
                showAlert("支付失败");
            }
        });
}

const showAlert=(msg)=> {
  showDialog({
    title: '提示',
    message: msg
  })
}



export const wechatMpPay=(options)=> {
    options.timeStamp = String(options.timeStamp) // 需要将时间戳转字符串，否则会提示‘缺少参数 timeStamp’
    if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', function () {
                onBridgeReady(options);
            }, false);
        } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', function () {
                onBridgeReady(options);
            });
            document.attachEvent('onWeixinJSBridgeReady', function () {
                onBridgeReady(options);
            });
        }
    } else {
        onBridgeReady(options);
    }
}


